module.exports = __webpack_public_path__ + "assets/img/i3.fbf114d4.png";